import { Component, Input } from '@angular/core';

import { CustomFormGroup } from '../../utilities';

@Component({
  selector: 'phoenix-form-errors',
  templateUrl: './form-errors.component.html',
  styleUrls: [],
  standalone: false,
})
export class FormErrorsComponent {
  @Input() form!: CustomFormGroup;
  @Input() showNestedError = true;
  @Input() title = 'Errors';

  nestedErrors(): any[] {
    if (this.form?.allErrors) {
      return this.form.allErrors.filter(
        (item, index, self) =>
          item.isNested &&
          self.findIndex(
            selfItem => selfItem.parent_control === item.parent_control
          ) === index
      );
    } else {
      return [];
    }
  }
}
